// extracted by mini-css-extract-plugin
export var buttonContainer = "DevResource-module__buttonContainer___w4Avu";
export var medium = "860px";
export var titleItem = "DevResource-module__titleItem___N57Qc";